import CampaignService from '@/services/campaign.service'
import AppService from '@/services/app.service'
import {campaignActionTypes} from '@/store/actionTypes'
import $filters from "@/modules/fptai/filters/filters";
import userStore from "@/store/modules/user/user.store";
import $utils from '@/utils/utils'

const types = campaignActionTypes

const state = {
    campaign: null,
    campaignConfig: null,
    isEdit: false,
    bots: null,
    isCallTestInbound: false,
    serviceNumbersCalled: [],
    nlus: null,
}

const mutations = {
    [types.UPDATE_CAMPAIGN]: (state, campaign) => {
        if (typeof campaign === "boolean") {
            state.campaign = campaign
        } else {
            state.campaign = {...campaign}
        }
    },
    [types.SET_CAMPAIGN_CONFIG]: (state, campaignConfig) => {
        state.campaignConfig = campaignConfig
    },
    [types.IS_EDIT]: (state, boolean) => {
        state.isEdit = !!(boolean)
    },
    [types.SET_BOTS]: (state, bots) => {
        state.bots = bots
    },
    [types.IS_CALL_TEST_INBOUND]: (state, boolean) => {
        state.isCallTestInbound = !!(boolean)
    },
    [types.SERVICE_NUMBERS_CALLED]: (state, serviceNumbersCalled) => {
        state.serviceNumbersCalled = serviceNumbersCalled
    },
    [types.SET_NLUS]: (state, nlus) => {
        state.nlus = nlus
    },
}

const actions = {
    [types.UPDATE_CAMPAIGN]({commit}, {campaign, model}) {
        return new Promise((resolve, reject) => {
            if (!campaign && !model) {
                commit(types.UPDATE_CAMPAIGN, null)
                reject()
            }

            let promise
            if (campaign) {
                if (!campaign.owner || campaign.owner === '') {
                    campaign.owner = userStore.state.profile.email
                }

                if (model.bot) {
                    model.bot = typeof model.bot === 'object' ? model.bot.id : model.bot
                } else if (model.tova_agent) {
                    model.tova_agent = typeof model.tova_agent === 'object' ? model.tova_agent.id : model.tova_agent
                }
                promise = CampaignService.CRUD.update(campaign.id, model)
            } else {
                if (!model.owner || model.owner === '') {
                    model.owner = userStore.state.profile.email
                }

                promise = CampaignService.createCampaign(model)
            }

            const i18n = {
                action: campaign ? $filters.tc('update') : $filters.tc('create'),
                item: window.vueapp.$t('campaign')
            }
            promise.then(result => {
                commit(types.UPDATE_CAMPAIGN, result.data)
                AppService.toastSuccess($filters.tc('actionSuccessful', i18n))
                resolve(result.data)
            }, err => {
                commit(types.UPDATE_CAMPAIGN, false)
                AppService.handleRequestError($filters.tc('actionFailed', i18n))
                reject(err)
            })
        })
    },
    [types.GET_CAMPAIGN_CONFIG]({commit}, payload) {
        let campaignId = payload || window.vueapp.$route.params.campaignId
        return CampaignService.getConfigs(campaignId).then(
            result => {
                delete result.data['zalo_config']
                commit(types.SET_CAMPAIGN_CONFIG, result.data)
            }
        )
    },
    [types.SET_DATA]({commit}, data) {
        return new Promise(resolve => {
            commit(types.UPDATE_CAMPAIGN, data)
            resolve()
        })
    },
    [types.IS_EDIT]({commit}, boolean) {
        commit(types.IS_EDIT, boolean)
    },
    [types.GET_BOTS](context) {
        CampaignService.getBots().then(
            result => {
                let data = result.data
                context.dispatch(types.SET_BOTS, data)
            },
            AppService.handleRequestError()
        )
    },
    [types.SET_BOTS]: ({commit}, bots) => {
        commit(types.SET_BOTS, bots)
    },
    [types.IS_CALL_TEST_INBOUND]({commit}, boolean) {
        commit(types.IS_CALL_TEST_INBOUND, boolean)
    },
    [types.SAVE_SERVICE_NUMBER_CALLED]({commit, state}, data) {
        const crrServiceNumbersCalled = $utils.cloneObject(state.serviceNumbersCalled)
        const existSN = crrServiceNumbersCalled.find(i => i.customerId === data.customerId)
        if (existSN) {
            existSN.customerId = data.customerId
            existSN.idCalledList.push(data.serviceNumberId)
        } else {
            crrServiceNumbersCalled.push({
                customerId: data.customerId,
                idCalledList: [data.serviceNumberId]
            })
        }
        commit(types.SERVICE_NUMBERS_CALLED, crrServiceNumbersCalled)
    },
    [types.RESET_SERVICE_NUMBER_CALLED]({commit}) {
        commit(types.SERVICE_NUMBERS_CALLED, [])
    },
    [types.GET_NLUS](context, data) {
        let tenantName = data.tenantName
        let isAuto = data.isAuto
        CampaignService.getNlus(tenantName).then(
            result => {
                let data = result.data
                let cnt = data.length
                context.commit(types.SET_NLUS, data)
                if (!isAuto) {
                    AppService.toastSuccess($filters.tc('actionSuccessful', {
                        action: $filters.tc('get'),
                        item: cnt + " " + $filters.tc('nlu')
                    }))
                }
            },
            AppService.handleRequestError()
        )
    },
    [types.SET_NLUS]: ({commit}, bots) => {
        commit(types.SET_NLUS, bots)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
